import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'input-form',
  templateUrl: './input-form.component.html',
  styleUrls: ['./input-form.component.scss']
})
export class InputFormComponent implements OnInit {

  @Input() form;
  @Input() type: string;
  @Input() id: string;
  @Input() msgErrorValidator: string;
  @Input() label: string;
  @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
